import { useState, useMemo } from "react";
import { ContractManageList } from "src/api/contract/contract-types";
import { AssignedContractModel } from "src/api/contractGroup/contractgroup-type";
import { BaseButton } from "src/components";
import BaseChip from "src/components/BaseChip";
import { Modal, SelectOption } from "src/pages/building/building-types";
import SpaceBaseTable from "src/pages/product/forms/commonSpaceForm/components/SpaceBaseTable";
import { AssignedContractColumns } from "../../form/columns/AssignedContractColumns";
import ContractListColumns from "../../form/columns/ContractListColumns";
import ContractModal from "../../form/components/ContractModal";

const TYPE_OPTIONS = [
  { label: "전체", value: "ALL" },
  { label: "공간임대", value: "FULL_COURT" },
  { label: "공간예약", value: "TIME_COURT" },
  { label: "비상주", value: "NON_RESIDENT_OFFICE" },
];

type Props = {
  contractSummaryList: AssignedContractModel[];
  handleAddContract: (contractList: ContractManageList[]) => Promise<void>;
  handleDeleteContract: (contract: AssignedContractModel) => Promise<void>;
  addableContractIds: string[];
};

const AssginedContractTable = ({ contractSummaryList, handleAddContract, handleDeleteContract, addableContractIds }: Props) => {
  const [selectedTab, setSelectedTab] = useState<SelectOption>(TYPE_OPTIONS[0]);
  const [openContractModal, setOpenContractModal] = useState<Modal>({
    isOpen: false,
  });

  // 선택된 탭에 따라 계약 목록 필터링
  const filteredContractList = useMemo(() => {
    if (selectedTab.value === "ALL") {
      return contractSummaryList;
    }

    return contractSummaryList.filter((contract) => contract.spaceProductType === selectedTab.value);
  }, [contractSummaryList, selectedTab]);
  return (
    <>
      <article className="contents-container__wrap-article full-width">
        <div className="contents-container__sub-title ">
          <div className="flex-center-start w-100">
            <h2 className="minmax40">계약</h2>
            <div className="flex-center-center ml20 gap8">
              <BaseChip title="전체" selected={selectedTab.value === "ALL"} onClick={() => setSelectedTab(TYPE_OPTIONS[0])} />
              <BaseChip title="공간임대" selected={selectedTab.value === "FULL_COURT"} onClick={() => setSelectedTab(TYPE_OPTIONS[1])} />
              <BaseChip title="공간예약" selected={selectedTab.value === "TIME_COURT"} onClick={() => setSelectedTab(TYPE_OPTIONS[2])} />
              <BaseChip title="비상주" selected={selectedTab.value === "NON_RESIDENT_OFFICE"} onClick={() => setSelectedTab(TYPE_OPTIONS[3])} />
            </div>
          </div>
          <div className="">
            <BaseButton
              title="계약 추가"
              onClick={() => {
                setOpenContractModal({
                  isOpen: true,
                });
              }}
            />
          </div>
        </div>

        {/* 계약 매핑 목록 테이블 */}
        <SpaceBaseTable columns={AssignedContractColumns} data={filteredContractList} handleDeleteContract={handleDeleteContract} />
      </article>

      {/* 계약 추가 모달 */}
      {openContractModal.isOpen && (
        <ContractModal
          columns={ContractListColumns} //
          checkboxType="checkbox"
          title="신청/계약 선택"
          onClick={(list: ContractManageList[]) => {
            handleAddContract(list);
            setSelectedTab(TYPE_OPTIONS[0]);
          }}
          onClose={() => setOpenContractModal({ isOpen: false })}
          addedList={[]}
          isSearched={false}
          addableContractIds={addableContractIds}
        />
      )}
    </>
  );
};

export default AssginedContractTable;
